<template>
  <currency-input
      v-model="value"
      :name="input_name"
      v-currency="{currency: null}"
  />
</template>

<script>
export default {
  mounted() {
    this.value = this.input_value;
  },

  data()  {
      return {
          value: null
      }
  },

  props: {
    input_class: {
      type: String,
      default: ""
    },
    input_name: {
      type: String,
      required: true
    },

    input_value: {
      type: String,
    }
  }
}
</script>